module.exports = __webpack_public_path__ + "img/Gran_Coupé_mobile.94036a19.jpg";